export default {"src":"/_next/static/media/itc.efa8ee00.svg","height":121,"width":170,"blurWidth":0,"blurHeight":0};